// services/backlogService.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Crear un nuevo item de backlog
 */
export const createBacklogItem = async (data) => {
  const formData = new FormData();
  formData.append("tipo", data.tipo);
  formData.append("titulo", data.titulo);
  formData.append("descripcion", data.descripcion);
  if (data.prioridad) {
    formData.append("prioridad", data.prioridad);
  }
  if (data.archivo) {
    formData.append("archivo", data.archivo);
  }

  const token = localStorage.getItem("token");
  const response = await axios.post(`${API_URL}/backlog`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

/**
 * Obtener items de backlog con filtros
 */
export const getBacklogItems = async (filters = {}) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/backlog`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filters,
  });
  return response.data;
};

/**
 * Obtener un item de backlog por ID
 */
export const getBacklogItemById = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/backlog/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Actualizar un item de backlog (solo admin)
 */
export const updateBacklogItem = async (id, data) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/backlog/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Responder a un item de backlog (solo admin)
 */
export const respondBacklogItem = async (id, respuestaAdmin, nuevoEstado) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/backlog/${id}/responder`,
    { respuestaAdmin, nuevoEstado },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

/**
 * Completar un item de backlog (solo admin)
 */
export const completeBacklogItem = async (id, respuestaAdmin) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/backlog/${id}/completar`,
    { respuestaAdmin },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

/**
 * Rechazar un item de backlog (solo admin)
 */
export const rejectBacklogItem = async (id, respuestaAdmin) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/backlog/${id}/rechazar`,
    { respuestaAdmin },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

/**
 * Obtener estadísticas del backlog (solo admin)
 */
export const getBacklogStats = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/backlog/stats`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Eliminar un item de backlog (solo admin)
 */
export const deleteBacklogItem = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/backlog/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Obtener URL de descarga de archivo adjunto
 */
export const getBacklogFileUrl = (id) => {
  const token = localStorage.getItem("token");
  return `${API_URL}/backlog/${id}/archivo?token=${token}`;
};

/**
 * Descargar archivo adjunto
 */
export const downloadBacklogFile = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/backlog/${id}/archivo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });
  return response.data;
};
